import React, { ReactNode } from 'react'
import { Field } from 'formik'

export interface Option {
  key: string
  value: string
}

export interface SelectProps extends React.HTMLAttributes<HTMLElement> {
  label: string
  name: string
  selectStyling: string
  fieldStyling: string
  options: Option[]
  children: ReactNode
}

function Select(props: SelectProps): JSX.Element {
  const {
    label,
    name,
    selectStyling,
    fieldStyling,
    options,
    children,
    ...rest
  } = props
  return (
    <div className={selectStyling}>
      <label htmlFor={name}>{label}</label>
      <Field
        className={fieldStyling}
        as='select'
        id={name}
        name={name}
        {...rest}
      >
        {options.map((option) => {
          return (
            <option key={option.value} value={option.value}>
              {option.key}
            </option>
          )
        })}
      </Field>
      {children}
    </div>
  )
}

export default Select
